import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
//import { GlobalConstants } from 'src/app/common/global-constants';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  //readonly BaseURI = GlobalConstants.apiURL;
  BaseURI : string;
  readonly apiController = "/Countries";

  constructor(private http : HttpClient) {
    console.log("constructor : CountryService ");
    this.BaseURI = window.location.origin + "/api";
  }


   getDetail(id)
   {
      return this.http.get(this.BaseURI + this.apiController + "/" + id);
   }


   getList()
   {
      return this.http.get(this.BaseURI + this.apiController);
   }
}
